import React from "react";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";

type Props = {
  onlineColumns:columnTypes[];
  cashColumns: columnTypes[];
  withdrawl:(value:number)=>void;
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    setIsOpenInDialog: (newValue: boolean) => void;
    setIsOpenOutDialog: (newValue: boolean) => void;
    setIsOpenExchangeDialog: (newValue: boolean) => void;
  };
};

const DrawerAmountListing = ({
  onlineColumns,
  cashColumns,
  withdrawl,
  rows,
  paginationProps: {
    isTableLoading,
    setIsOpenInDialog,
    setIsOpenOutDialog,
    setIsOpenExchangeDialog
  },
}: Props) => {
  const navigate=useNavigate()
  const onlinePayments = (rows || []).filter((item: any) => item.type === "VIRTUAL");
  const cashDrawers = (rows || []).filter((item: any) => item.type==="PHYSICAL");

  const cashDrawerTotal = cashDrawers.reduce(
    (sum: any, item: any) => sum + Number(item.totalAmt || 0),
    0
  );

  const onlinePaymentsTotal = onlinePayments.reduce(
    (sum: any, item: any) => sum + Number(item.totalAmt || 0),
    0
  );

  const cashDrawerWithTotal = [
    ...cashDrawers,
    {
      _id: "cash-total-row",
      name: "Total",
      quantity: "",
      totalAmt: cashDrawerTotal,
      isTotalRow: true,
    },
  ];

  const onlinePaymentsWithTotal = [
    ...onlinePayments,
    {
      _id: "online-total-row",
      name: "Total",
      totalAmt: onlinePaymentsTotal,
      isTotalRow: true,
    },
  ];
  const totalAmount= cashDrawerTotal+onlinePaymentsTotal

  const actionButtonClass = "w-auto shrink-0 whitespace-nowrap px-4";

  return (
    <SideNavLayout>
      <div className="flex flex-col gap-4 p-4">
        <ATMPageHeader
          moduleName="DRAWER"
          pageTitle="Drawers"
          hideSearchBox={true}
          buttonProps={{
            btnName: "Withdraw All",
            className: `${actionButtonClass} bg-white text-primary-main border-primary-main`,
            onClick: () => {
              withdrawl(totalAmount);
            },
          }}
          extraButton={true}
          extraButtonProps={[
            {
              btnName: "Cash In",
              className: actionButtonClass,
              onClick: () => {
                navigate("/cash-in");
              },
            },
            {
              btnName: "Cash Out",
              className: actionButtonClass,
              onClick: () => {
                navigate("/cash-out");
              },
            },
            {
              btnName: "Exchange",
              className: actionButtonClass,
              onClick: () => {
                navigate("/cash-exchange");
              },
            },
          ]}
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
          <div className="border border-slate-200 rounded-lg bg-white shadow-sm overflow-hidden">
            <div className="px-4 py-3 text-base font-semibold text-slate-700 border-b border-slate-200">
              Cash Drawers
            </div>
            <div className="p-3 overflow-auto">
              <ATMTable
                columns={cashColumns}
                rows={cashDrawerWithTotal}
                rowExtraClasses={(row) =>
                  row.isTotalRow ? "font-semibold bg-gray-100" : "min-h-[40px]"
                }
                isLoading={isTableLoading}
              />
            </div>
          </div>

          <div className="border border-slate-200 rounded-lg bg-white shadow-sm overflow-hidden">
            <div className="px-4 py-3 text-base font-semibold text-slate-700 border-b border-slate-200">
              Online Payments
            </div>
            <div className="p-3 overflow-auto">
              <ATMTable
                columns={onlineColumns}
                rows={onlinePaymentsWithTotal}
                rowExtraClasses={(row) =>
                  row.isTotalRow ? "font-semibold bg-gray-100" : "min-h-[40px]"
                }
                isLoading={isTableLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </SideNavLayout>
  );
};

export default DrawerAmountListing;
